module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-3-5cac5329.webp";